import { useEffect, useState } from 'react'
import { DataType } from '../../../../../tables'
import { FieldType, FieldValue, FilterField, Filters, O } from '../../../../../features/ui'
import { useCreditCardHooks } from '../../../hooks/creditCardHooks'
import { CreditCard } from '../../../state/types'

type Props = {
    creditCards: CreditCard[]
    onSearchStart: () => void
    onSearchDone: (dataTypes: DataType[]) => void
}

const FiltersKey = 'creditCard'

export const CreditCardFilters = (props: Props) => {
    const { creditCards, onSearchStart, onSearchDone } = props

    const [searchText, setSearchText] = useState<string>()

    const { searchCreditCards } = useCreditCardHooks()

    useEffect(() => search(searchText), [creditCards])

    const search = (searchTextParam?: string) => {
        onSearchStart()
        searchCreditCards(creditCards, searchTextParam).then(searchedList => {
            setTimeout(() => onSearchDone(searchedList as DataType[]), 100)
        })
    }

    const handleSearch = (value?: FieldValue) => {
        const newSearchText = value as O<string>
        setSearchText(newSearchText)
        search(newSearchText)
    }

    const searchField: FilterField = {
        name: 'search',
        type: FieldType.TEXT,
        placeholder: 'Buscar por tipo, emisor, titular o número',
        icon: 'search',
        onChange: handleSearch
    }

    return (
        <Filters
            filtersKey={FiltersKey}
            searchField={searchField}
        />
    )
}
